import { defineMessages } from 'react-intl';

export default defineMessages({
  charityVettingRgseaaRequiredES: {
    id: 'charityVetting.es.rgseaa.required',
    defaultMessage: 'RGSEAA is required',
  },
  charityVettingCifRequiredES: {
    id: 'charityVetting.es.cif.required',
    defaultMessage: 'The NIF number is required.',
  },
});
